import { configureStore } from '@reduxjs/toolkit';
import { authApi, dataApi } from 'services/data/DataService';
import { getTenant } from 'app/getTenant';
import { createPersistenceMiddleware } from './persistence/persistence';
import { rootReducer } from './rootReducer';
import persistenceConfig from './persistence/persistenceConfig';
import { persistenceListener } from './persistence/persistenceListener';


const tenant = getTenant();

export const store = configureStore({
  
  reducer: rootReducer,
  
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware()
      .prepend(persistenceListener.middleware)
      .concat(
        dataApi.middleware, 
        authApi.middleware,
        ...(tenant ? [createPersistenceMiddleware(tenant, persistenceConfig)] : [])
      )

});
